import React, { useEffect, useState } from 'react';
import { LoginPage } from '../components/LoginPage';
import { AuthProvider } from './AuthContext';
import { limsClient } from '../api/limsClient';

interface AuthGateProps {
  children: React.ReactNode;
}

interface AuthState {
  status: 'loading' | 'authenticated' | 'unauthenticated';
  email: string;
  name: string;
  isAdmin: boolean;
}

export function AuthGate({ children }: AuthGateProps) {
  const [auth, setAuth] = useState<AuthState>({ status: 'loading', email: '', name: '', isAdmin: false });

  useEffect(() => {
    fetch('/auth/me')
      .then(res => res.json())
      .then(async data => {
        if (data.authenticated) {
          try {
            const user = await limsClient.syncUser(data.email, data.name);
            setAuth({ status: 'authenticated', email: data.email || '', name: data.name || '', isAdmin: user.is_admin });
          } catch {
            setAuth({ status: 'authenticated', email: data.email || '', name: data.name || '', isAdmin: false });
          }
        } else {
          setAuth({ status: 'unauthenticated', email: '', name: '', isAdmin: false });
        }
      })
      .catch(() => setAuth({ status: 'unauthenticated', email: '', name: '', isAdmin: false }));
  }, []);

  if (auth.status === 'loading') return null;
  if (auth.status === 'unauthenticated') return <LoginPage />;
  return (
    <AuthProvider user={{ email: auth.email, name: auth.name, isAdmin: auth.isAdmin }}>
      {children}
    </AuthProvider>
  );
}
